import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from "@angular/platform-browser";
import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
import {downgradeModule} from "@angular/upgrade/static";
import {ScrollingModule} from "@angular/cdk/scrolling";
import {CommonsModule} from "../../commons/angular/commons.module";
import {TranslateModule} from "@ngx-translate/core";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxPermissionsModule} from "ngx-permissions";
import {PlanningDraftJobsPanelListComponent} from "./components/planning-draft-jobs-panel-list/planning-draft-jobs-panel-list.component";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {PlanningDraftJobsPanelListItemComponent} from "./components/planning-draft-jobs-panel-list-item/planning-draft-jobs-panel-list-item.component";
import {PlanningPackagesSpotsPipe} from "./pipes/planning-packages-spots.pipe";
import {PlanningPackagesWeightPipe} from "./pipes/planning-packages-weight.pipe";
import {PlanningPackagesVolumePipe} from "./pipes/planning-packages-volume.pipe";
import {PlanningPackagesPipe} from "./pipes/planning-packages.pipe";
import {PlanningDraftRoutesPanelListComponent} from "./components/planning-draft-routes-panel-list/planning-draft-routes-panel-list.component";
import {PlanningDraftRoutesPanelListItemComponent} from "./components/planning-draft-routes-panel-list-item/planning-draft-routes-panel-list-item.component";
import {PlanningDraftRoutePanelActivityItemComponent} from "./components/planning-draft-route-panel-activity-item/planning-draft-route-panel-activity-item.component";
import {PlanningDraftRoutePanelViewTestComponent} from "./components/planning-draft-route-panel-view-test/planning-draft-route-panel-view-test.component";
import {PlanningActivityTimeWindowPipe} from "./pipes/planning-activity-time-window.pipe";
import {PlanningDraftResourcesPanelListComponent} from "./components/planning-draft-resources-panel-list/planning-draft-resources-panel-list.component";
import {PlanningDraftResourcesPanelListItemComponent} from "./components/planning-draft-resources-panel-list-item/planning-draft-resources-panel-list-item.component";
import {PlanningDraftResourcePanelViewComponent} from "./components/planning-draft-resource-panel-view/planning-draft-resource-panel-view.component";
import { ScrollingModule as ScrollingModuleExperimental } from '@angular/cdk-experimental/scrolling';
import {PlanningActivityOverviewCardComponent} from "./components/planning-activity-overview-card/planning-activity-overview-card.component";
import {PlanningReportsTableComponent} from "./components/planning-reports-table/planning-reports-table.component";
import {
  PlanningReportsTableRowComponent
} from "./components/planning-reports-table-row/planning-reports-table-row.component";
import {PlanningDraftJobsPanelEditableListComponent} from "./components/planning-draft-jobs-panel-editable-list/planning-draft-jobs-panel-editable-list.component";
import {
  PlanningGroupedJobsListPanelComponent
} from "./components/planning-grouped-jobs-list-panel/planning-grouped-jobs-list-panel.component";
import {AccountsModule} from "../../account/angular/accounts.module";
import {AddressesModule} from "../../addresses/angular/addresses.module";
import {
  PlanningProjectDraftSelectComponent
} from "./components/planning-project-draft-select/planning-project-draft-select.component";
import {
  PlanningProjectDraftSelectListComponent
} from "./components/planning-project-draft-select-list/planning-project-draft-select-list.component";
import {
  PlanningProjectsSelectComponent
} from "./components/planning-projects-select/planning-projects-select.component";
import {
  PlanningProjectsSelectListComponent
} from "./components/planning-projects-select-list/planning-projects-select-list.component";
import {TasksModule} from "../../tasks/angular/tasks.module";
import {
  PlanningDefaultDraftDialogComponent
} from "./components/planning-default-draft-dialog/planning-default-draft-dialog.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { planningDefaultDraftsFeature } from './state/planning-default-drafts.state';
import * as planningDefaultDraftsEffects from './state/planning-default-drafts.effects';
import { planningDraftJobChangesFeature } from './state/planning-draft-job-changes.state';
import * as planningDraftJobChangesEffects from './state/planning-draft-job-changes.effects';
import { CommonModule } from '@angular/common';
import { PlanningDefaultDraftsFacadeService } from './services/planning-default-drafts-facade.service';
import {
  PlanningDraftRoutesSortingDialogComponent
} from "./components/planning-draft-routes-sorting-dialog/planning-draft-routes-sorting-dialog.component";
import {
  PlanningDraftJobsSortingDialogComponent
} from "./components/planning-draft-jobs-sorting-dialog/planning-draft-jobs-sorting-dialog.component";
import {PlanningDraftJobsTableListComponent} from "./components/planning-draft-jobs-table-list/planning-draft-jobs-table-list.component";
import {PlanningDraftJobsTableListRowComponent} from "./components/planning-draft-jobs-table-list-row/planning-draft-jobs-table-list-row.component";
import {PlanningDraftRoutesTableListComponent} from "./components/planning-draft-routes-table-list/planning-draft-routes-table-list.component";
import {PlanningDraftResourcesTableListComponent} from "./components/planning-draft-resources-table-list/planning-draft-resources-table-list.component";
import {PlanningDraftRoutesTableListItemComponent} from "./components/planning-draft-routes-table-list-item/planning-draft-routes-table-list-item.component";
import {PlanningDraftResourcesTableListItemComponent} from "./components/planning-draft-resources-table-list-item/planning-draft-resources-table-list-item.component";
import {PlanningPackagesPalletsPipe} from "./pipes/planning-packages-pallets.pipe";
import {
  PlanningDefaultDraftsTableComponent
} from "./components/planning-default-drafts-table/planning-default-drafts-table.component";
import {
  PlanningDefaultDraftsTableRowComponent
} from "./components/planning-default-drafts-table-row/planning-default-drafts-table-row.component";
import {PlanningDraftResourcesSortingDialogComponent} from "./components/planning-draft-resources-sorting-dialog/planning-draft-resources-sorting-dialog.component";
import {PlanningDraftRouteTableDrilldownComponent} from "./components/planning-draft-route-table-drilldown/planning-draft-route-table-drilldown.component";
import {PlanningDraftResourceTableDrilldownComponent} from "./components/planning-draft-resource-table-drilldown/planning-draft-resource-table-drilldown.component";
import { PlanningDraftRoutePanelContextMenuComponent } from "./components/planning-draft-route-panel-context-menu/planning-draft-route-panel-context-menu.component";
import {PlanningRouteActionMenuComponent} from "./components/planning-route-action-menu/planning-route-action-menu.component";


import {
  PlanningDraftRouteJobSplitByPackagesComponent
} from "./components/planning-draft-route-job-split-by-packages/planning-draft-route-job-split-by-packages.component";
import {
  PlanningDraftRouteJobSplitByLocationComponent
} from "./components/planning-draft-route-job-split-by-location/planning-draft-route-job-split-by-location.component";
import {DepotsModule} from "../../depots/angular/depots.module";
import {
  PlanningDraftRouteJobSplitRevertComponent
} from "./components/planning-draft-route-job-split-revert/planning-draft-route-job-split-revert.component";
import { PlanningDraftJobActionMenuComponent } from "./components/planning-draft-job-action-menu/planning-draft-job-action-menu.component";
import { PendingFieldRowComponent } from "./components/pending-field-row/pending-field-row.component";
import { PlanningDraftJobPackageDeltaComponent } from "./components/planning-draft-job-package-delta/planning-draft-job-package-delta.component";
import { PlanningDraftJobStopChangeComponent } from "./components/planning-draft-job-stop-change/planning-draft-job-stop-change.component";
import { PlanningDraftJobSplitPlanComponent } from "./components/planning-draft-job-split-plan/planning-draft-job-split-plan.component";
import { PlanningDraftJobChangeDiffComponent } from "./components/planning-draft-job-change-diff/planning-draft-job-change-diff.component";
import { PlanningDraftJobChangeRowComponent } from "./components/planning-draft-job-change-row/planning-draft-job-change-row.component";
import { PlanningDraftJobChangesListComponent } from "./components/planning-draft-job-changes-list/planning-draft-job-changes-list.component";


@NgModule({
  declarations: [
    PlanningDraftJobsPanelListComponent,
    PlanningDraftJobsPanelListItemComponent,
    PlanningDraftJobActionMenuComponent,
    PlanningDraftJobsPanelEditableListComponent,
    PlanningDraftJobsTableListComponent,
    PlanningDraftJobsTableListRowComponent,
    PlanningDraftRoutesTableListComponent,
    PlanningDraftResourcesTableListComponent,
    PlanningDraftRoutesTableListItemComponent,
    PlanningDraftResourcesTableListItemComponent,
    PlanningDraftRouteTableDrilldownComponent,
    PlanningDraftResourceTableDrilldownComponent,
    PlanningDraftRoutesPanelListComponent,
    PlanningDraftRoutesPanelListItemComponent,
    PlanningDraftRoutePanelViewTestComponent,
    PlanningDraftRoutePanelActivityItemComponent,
    PlanningDraftRoutePanelContextMenuComponent,
    PlanningRouteActionMenuComponent,
    PlanningDraftRouteJobSplitByPackagesComponent,
    PlanningDraftRouteJobSplitByLocationComponent,
    PlanningDraftRouteJobSplitRevertComponent,
    PlanningActivityOverviewCardComponent,
    PlanningDraftResourcesPanelListComponent,
    PlanningDraftResourcesPanelListItemComponent,
    PlanningDraftResourcePanelViewComponent,
    PlanningPackagesSpotsPipe,
    PlanningPackagesPalletsPipe,
    PlanningPackagesWeightPipe,
    PlanningPackagesVolumePipe,
    PlanningPackagesPipe,
    PlanningActivityTimeWindowPipe,
    PlanningReportsTableComponent,
    PlanningReportsTableRowComponent,
    PlanningGroupedJobsListPanelComponent,
    PlanningProjectDraftSelectComponent,
    PlanningProjectDraftSelectListComponent,
    PlanningProjectsSelectComponent,
    PlanningProjectsSelectListComponent,
    PlanningDefaultDraftDialogComponent,
    PlanningDraftRoutesSortingDialogComponent,
    PlanningDraftResourcesSortingDialogComponent,
    PlanningDraftJobsSortingDialogComponent,
    PlanningDefaultDraftsTableComponent,
    PlanningDefaultDraftsTableRowComponent,
    PendingFieldRowComponent,
    PlanningDraftJobPackageDeltaComponent,
    PlanningDraftJobStopChangeComponent,
    PlanningDraftJobSplitPlanComponent,
    PlanningDraftJobChangeDiffComponent,
    PlanningDraftJobChangeRowComponent,
    PlanningDraftJobChangesListComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    ScrollingModule,
    ScrollingModuleExperimental,
    CommonsModule,
    FormsModule,
    ReactiveFormsModule,
    AccountsModule,
    TasksModule,
    DragDropModule,
    NgbModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild(),
    AddressesModule,
    NgSelectModule,
    StoreModule.forFeature(planningDefaultDraftsFeature),
    EffectsModule.forFeature([planningDefaultDraftsEffects]),
    StoreModule.forFeature(planningDraftJobChangesFeature),
    EffectsModule.forFeature([planningDraftJobChangesEffects]),
    DepotsModule
  ],
  providers: [],
  exports: [
    // PlanningDraftJobsPanelListComponent,
    // PlanningDraftJobsPanelListItemComponent
  ]
})

export class PlanningModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapPlanningModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(PlanningModule);
};

export const downgradedPlanningModule = downgradeModule(bootstrapPlanningModule);
